/**
 * NIASBiz.API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NIASBizBllModelsAuthDocumentQuery { 
    PersonSearch?: string;
    LegalSearch?: string;
    ForPersonSearch?: string;
    ServiceSearch?: string;
    SearchFromLegal?: string;
    SearchDocumentStateIds?: Array<number>;
    DocumentIdQuery?: string;
    AuthListType?: NIASBizBllModelsAuthDocumentQuery.AuthListTypeEnum;
    ServiceUserType?: NIASBizBllModelsAuthDocumentQuery.ServiceUserTypeEnum;
    IsAdministrationOnly?: boolean;
    Skip?: number;
    Take?: number;
    SearchQuery?: string;
    SortBy?: NIASBizBllModelsAuthDocumentQuery.SortByEnum;
    SortByDirection?: NIASBizBllModelsAuthDocumentQuery.SortByDirectionEnum;
}
export namespace NIASBizBllModelsAuthDocumentQuery {
    export const AuthListTypeEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    } as const;
    export type AuthListTypeEnum = typeof AuthListTypeEnum[keyof typeof AuthListTypeEnum];
    export const ServiceUserTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    } as const;
    export type ServiceUserTypeEnum = typeof ServiceUserTypeEnum[keyof typeof ServiceUserTypeEnum];
    export const SortByEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8,
        NUMBER_9: 9
    } as const;
    export type SortByEnum = typeof SortByEnum[keyof typeof SortByEnum];
    export const SortByDirectionEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    } as const;
    export type SortByDirectionEnum = typeof SortByDirectionEnum[keyof typeof SortByDirectionEnum];
}


